<template>
  <Modal class-name="vertical-center-modal" v-model="isModal" title="用户详细信息" width="300">
    <div class="form-wrapper">
      <div class="tab-box">
        <div class="tab-div" :class="tabActive == 0 ? 'active' : ''" @click="changeTab(0)">基础信息</div>
        <div class="tab-div" :class="tabActive == 1 ? 'active' : ''" @click="changeTab(1)">直推团队</div>
        <div class="tab-div" :class="tabActive == 2 ? 'active' : ''" @click="changeTab(2)">二级团队</div>
      </div>
      <div class="padding-t-10" v-if="tabActive == 0">
        <Form ref="userForm" :model="userForm" label-position="right" :label-width="90">
          <FormItem label="用户UUID:">
            <div class="form-group">
              <div class="color-222" style="word-break: break-all;">{{userForm.uuid}}</div>
            </div>
          </FormItem>
          <FormItem label="注册时间:">
            <div class="form-group">
              <div class="color-222">{{userForm.createTime}}</div>
            </div>
          </FormItem>
          <FormItem label="推荐人ID:">
            <div class="form-group">
              <div class="color-222">{{userForm.parentUuid}}</div>
            </div>
          </FormItem>
          <FormItem label="支付宝账号:">
            <div class="form-group">
              <div class="color-222">{{userForm.alipay}}</div>
            </div>
          </FormItem>
          <FormItem label="可用金额:">
            <div class="form-group">
              <div class="color-222">{{userForm.balance}}</div>
            </div>
          </FormItem>
          <FormItem label="是否总监:">
            <div class="form-group">
              <div class="color-222">{{userForm.isMajor?'是':'否'}}</div>
            </div>
          </FormItem>
        </Form>
      </div>
      <div class="padding-t-10" v-if="tabActive == 1">
        <Table border :columns="columns" :data="listDirctor" :loading="loading"></Table>
        <div style="padding: 10px 0px">
          <Page key="tabActive1" :total="totalDirctor" :current="searchForm.pageNo" show-sizer show-elevator show-total @on-change="changePage"
                @on-page-size-change="changePagesize"></Page>
        </div>
      </div>
      <div class="padding-t-10" v-if="tabActive == 2">
        <Table border :columns="columns" :data="list" :loading="loading"></Table>
        <div style="padding: 10px 0px">
          <Page key="tabActive2" :total="total" :current="searchAccessForm.pageNo" show-sizer show-elevator show-total @on-change="changeAccessPage" @on-page-size-change="changeAccessPageSize"></Page>
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn" @click="handelCancel">确定</span>
      </div>
    </div>
    <Spin size="large" fix v-show="loading"></Spin>
  </Modal>
</template>

<script>
  import { Form, FormItem, Modal, Spin,Table, Page } from 'view-design'
  import member from '@/javaApi/member'
  const memberModel = new member()
  export default {
    name: "SetDirector",
    components: {
      Form,
      FormItem,
      Modal,
      Spin,
      Table,
      Page
    },
    data: function() {
      return {
        isModal: false,
        loading: false,
        tabActive: 0,
        userForm: {
          uuid: '',
          createTime: '暂无创建时间',
          parentUuid: '',
          alipay: '暂无支付宝',
          balance: '0.00',
          isMajor: 0,
          platformUuid:''
        },
        columns: [
          {
            title: '微信名',
            key: 'nickName',
            ellipsis: true,
            render: (h, params) => {
              let nickname= params.row.nickName
              let avatar = params.row.headPic
              let renderData = []
              if(avatar) {
                renderData.push(
                  h('img',{
                      attrs:{
                        src: avatar,
                        width: 20
                      },
                  })
                )
              }
              renderData.push(
                h('span', {}, nickname)
              )
              return renderData
            }
          },
          {
            title: '注册时间',
            key: 'createTime',
          }
        ],
        list:[
        ],
        listDirctor:[],
        total:0,
        totalDirctor:0,
        searchForm: {
          pageNo: 1,
          pageSize: 10,
        },
        searchAccessForm: {
          pageNo: 1,
          pageSize: 10,
        },
        type: 1,
      }
    },
    created:function(){
    },
    methods: {
      init: function(isModal,row) {
        this.loading = true
        this.isModal = isModal
        this.loading = false
        this.userForm = row
        if(!row.alipay){
          this.userForm.alipay = '暂无支付宝'
        }
        this.searchForm= {
         pageNo: 1,
         pageSize: 10,
        }
        this.searchAccessForm = {
          pageNo: 1,
          pageSize: 10,
        }
        this.tabActive = 0
        this.getDirectorList(true)
        this.getList(true)
      },
      changeTab: function(index) {
        this.tabActive = index;
        if(this.tabActive == 1){
          this.searchForm.pageNo = 1
          this.searchForm.pageSize = 10
          this.getDirectorList(true)
        }
        if(this.tabActive == 2){
          this.searchAccessForm.pageNo = 1
          this.searchAccessForm.pageSize = 10
          this.getList(true)
        }
      },
      handelCancel: function() {
        this.isModal = false
      },
      changePage(value){
        this.searchForm.pageNo = value
        this.getDirectorList()
      },
      changePagesize(value){
        this.searchForm.pageSize = value;
        //如果处于第一页改变数量，则会触发changePage
        if(this.searchForm.pageNo == 1){
          this.getDirectorList(true)
        }
      },

      changeAccessPage(value){
        this.searchAccessForm.pageNo = value
        this.getList()
      },
      changeAccessPageSize(value){
        this.searchAccessForm.pageSize = value;
        //如果处于第一页改变数量，则会触发changePage
        if(this.searchAccessForm.pageNo == 1){
          this.getList(true)
        }
      },

      getDirectorList(isfirst){
        if(isfirst){
          this.searchForm.pageNo = 1
        }
        let that =this
        memberModel.userQueryDirect({
          uuidOne: this.userForm.uuid,
          pageNo:this.searchForm.pageNo,
          pageSize:this.searchForm.pageSize
        }).then(response=>{
          let res = response.data
          if(res.code == 200){
            that.listDirctor = res.data.list
            that.totalDirctor = res.data.total
          }else{
            let message = res.message?res.message:'系统异常请稍后再试'
            that.$message.error(message)
          }
        }).catch(error=>{
            if(error != 'token invalid'){
                that.$message.error('系统异常请稍后再试')
            }

        })
      },
      getList(isfirst){
        if(isfirst){
          this.searchAccessForm.pageNo = 1
        }
        let that =this
        memberModel.userQueryAccess({
          uuidTwo: this.userForm.uuid,
          pageNo:this.searchAccessForm.pageNo,
          pageSize:this.searchAccessForm.pageSize
        }).then(response=>{
          let res = response.data
          if(res.code == 200){
            that.list = res.data.list
            that.total= res.data.total
          }else{
            let message = res.message?res.message:'系统异常请稍后再试'
            that.$message.error(message)
          }
        }).catch(error=>{
          if(error != 'token invalid'){
            that.$message.error('系统异常请稍后再试')
          }
        })
      }
    }
  }
</script>

<style scoped>
  >>>.vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  >>>.vertical-center-modal .ivu-modal {
    top: 0;
    width: 300px !important;
  }

  >>>.vertical-center-modal .ivu-modal-footer {
    border-top: none;
    padding: 12px 18px 20px 18px;
    text-align: right;
  }

  >>>.ivu-form-item {
    margin-bottom: 0;
  }

  >>> .ivu-table-header th {
    background-color: #FCFAF8 !important;
  }

  .form-wrapper .tab-box {
    display: flex;
    flex-direction: row;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-top: 1px solid #E8E8E8;
    border-bottom: 1px solid #E8E8E8;
    border-radius: 2px;
  }

  .form-wrapper .tab-box .tab-div {
    width: 100px;
    border-left: 1px solid #E8E8E8;
    cursor: pointer;
  }

  .form-wrapper .tab-box .tab-div:last-child {
    border-right: 1px solid #E8E8E8;
  }

  .form-wrapper .tab-box .tab-div.active {
    background: #FF9933;
    color: #FFFFFF;
  }

  .footer-wrapper {
    display: flex;
    min-width: 0;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .footer-wrapper .btn {
    display: block;
    width: 100%;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    border-radius: 20px;
    text-align: center;
  }

  .footer-wrapper .btn.confirm-btn {
    background: #ff8622;
    color: #fff;
  }

  .footer-wrapper .btn.cancel-btn {
    border: 1px solid #eeeeee;
    color: #222222;
    background: #F2F2F2;
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/official/member/modal/Detail.vue